import { Button, FormControl, InputLabel, MenuItem, Select, Switch, TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { safeDeepDel } from 'iotera-base/json';
import React, { Component } from 'react';
import {
  isCommand,
  QREQ_CONDITION_BOOL,
  QREQ_NONE, TYPE_LIST_TRANSACTION,
  QREQ_TAGS,
  isCustomCommand
} from '../../../../lib/components/Preference';
import { ioteraConfirmAlert } from '../../../../lib/components/react/react-confirm-alert';

/* Object Json */
import { parse, parseArray, safeDeepGet, safeDeepGetWithType, stringify } from 'iotera-base/json';
import { isObject } from 'iotera-base/object';
import { hasWhiteSpace } from '../../../../lib/function';

import { SelectionQuery } from '../../selection-query';
import { SelectionDevice } from '../../var-device';
import { SelectionFilter } from '../../var-filter';

export class DialogVarAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      varType: 'str',
      varKey: null
    }
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.clearState = this.clearState.bind(this);
    this.checkFinal = this.checkFinal.bind(this);
    this.handleSave = this.handleSave.bind(this)
    this.executeSave = this.executeSave.bind(this)
    this.checkSubmitable = this.checkSubmitable.bind(this)
  }

  handleClose() {
    const _this = this
    const _props = _this.props
    const _parent = safeDeepGet(_props, ['_parent'])
    _this.clearState();
    _parent.setState({
      dialogAddVar: false
    })
  }

  handleSave() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const _parent = safeDeepGet(_props, ['_parent']);
    let varType = safeDeepGetWithType(_state, ['varType'], '');
    let varKey = safeDeepGetWithType(_state, ['varKey'], '');
    let finalData = safeDeepGet(_state, ['finalData']);
    const isManual = safeDeepGetWithType(_state, ['isManual'], false);
    if (isObject(finalData) || isObject(parse(finalData))) {
      if (isManual && !isObject(finalData))
        finalData = parse(finalData)
      finalData._varType = varType;
    }
    if (hasWhiteSpace(varKey)) {
      _parent.props.showSingleNotification({ message: 'Key tidak boleh mengandung spasi!', level: 'error' });
      return;
    }
    if (varType === 'func') {
      let isSaveable = true;
      const length = varKey.length;
      if (length < 5) {
        isSaveable = false
      } else {
        let first = varKey.substring(0, 5);
        if (first !== 'func_') {
          isSaveable = false
        }
      }
      if (!isSaveable) {
        _parent.props.showSingleNotification({ message: 'Key dari function harus diawali \'func_\'', level: 'error' });
        return;
      }
    } else if (varType === 'filter') {
      const name = safeDeepGetWithType(finalData, ['name'], '')
      if (name === '') {
        _parent.props.showSingleNotification({ message: 'Label tidak boleh kosong', level: 'error' });
        return;
      }
      finalData.id = varKey
    }
    const currQueryType = safeDeepGetWithType(finalData, ['queryType'], QREQ_NONE);
    if (currQueryType === QREQ_CONDITION_BOOL) {
      let condition = safeDeepGetWithType(finalData, ['condition'], '');
      let true_condition = safeDeepGet(finalData, ['true_condition'], '');
      let false_condition = safeDeepGet(finalData, ['false_condition'], '');
      if (condition === '') {
        _parent.props.showSingleNotification({ message: 'Condition tidak boleh kosong', level: 'error' });
        return;
      } else if (true_condition === '') {
        _parent.props.showSingleNotification({ message: 'True condition tidak boleh kosong', level: 'error' });
        return;
      } else if (false_condition === '') {
        _parent.props.showSingleNotification({ message: 'False condition tidak boleh kosong', level: 'error' });
        return;
      }
    } else if (currQueryType === QREQ_TAGS) {
      let tags = safeDeepGetWithType(finalData, ['tags'], []);
      const length = tags.length;
      if (length < 1) {
        delete finalData.tags
      }
    }
    let executeSave = safeDeepGet(_this, ['executeSave'])
    let _var = safeDeepGetWithType(_parent, ['state', '_var'], {});
    if (varKey in _var) {
      _parent.setState({
        dialogAddVar: false
      })
      ioteraConfirmAlert(
        'Key sudah terdaftar!',
        <span>Apakah anda yakin untuk tetap simpan variabel ini?<br />(variabel lama dengan key sama akan ditimpa)</span>,
        null,
        () => executeSave(_var, varKey, finalData),
        null,
        () =>
          _parent.setState({
            dialogAddVar: true
          })
      )
    } else {
      executeSave(_var, varKey, finalData)
    }
  }

  executeSave(_var, varKey, finalData) {
    const _this = this
    const _props = _this.props
    const _parent = _props._parent;
    Object.assign(_var, {
      [varKey]: finalData
    })
    _parent.setState({ _var })
    _this.handleClose();
  }

  handleChange(event) {
    const _this = this
    const _state = _this.state
    const name = safeDeepGetWithType(event, ['target', 'name'], '');
    const value = safeDeepGet(event, ['target', 'value'], '');
    if (name === 'varType') {
      let varKey = safeDeepGetWithType(_state, ['varKey'], '');
      let first = ''
      if (varKey.length > 4) {
        first = varKey.substring(0, 5);
      }
      let isFuncFirst = first === 'func_' ? true : false
      if (value === 'func') {
        if (varKey === '' || varKey.length < 6) {
          if (varKey.length > 0 && !isFuncFirst) {
            varKey = 'func_' + varKey;
          } else {
            varKey = 'func_a';
          }
        } else {
          if (!isFuncFirst) {
            varKey = 'func_' + varKey
          }
        }
      } else {
        if (varKey.length > 5) {
          if (isFuncFirst) {
            varKey = varKey.substr(5);
          }
        }
      }
      _this.setState({ varKey, [name]: value, varValue: null, isSubmitable: false })
    } else if (name === 'varVar') {
      _this.setState({ varType: 'obj', varValue: value })
      _this.checkSubmitable(name, value)
    } else {
      _this.setState({ [name]: value });
      _this.checkSubmitable(name, value)
    }
  }

  checkSubmitable(name, value) {
    const _this = this
    const check = _this.checkFinal(name, value);
    let isSubmitable = safeDeepGetWithType(check, ['submitable'], false);
    const finalData = safeDeepGet(check, ['data']);
    let error = false;
    if (finalData === null || finalData === undefined) {
      isSubmitable = false;
      error = true;
    }
    let errorVarKey = false;
    if (name === 'varKey') {
      if (!isSubmitable) {
        errorVarKey = true
      }
    }
    _this.setState({ [name]: value, isSubmitable, finalData, error, errorVarKey })
  }

  clearState() {
    this.setState({
      varKey: null, varValue: null, error: false, varType: 'str'
    })
  }

  checkFinal(name, value) {
    const _this = this
    const _state = _this.state
    let varType = safeDeepGetWithType(_state, ['varType'], '');
    let varKey = safeDeepGetWithType(_state, ['varKey'], '');
    let isManual = safeDeepGetWithType(_state, ['isManual'], false);
    let valueTemp = '';
    if (varType === 'func' || varType === 'device' || varType === 'filter') {
      valueTemp = {};
    }
    let varValue = safeDeepGetWithType(_state, ['varValue'], valueTemp);
    if (isManual) {
      varValue = safeDeepGetWithType(_state, ['varVar'], '');
    }
    if (name === 'varKey') {
      varKey = value;
    } else if (name === 'varValue') {
      varValue = value;
    } else if (name === 'varVar') {
      varValue = value;
    }
    let _isObject = false;
    if (isObject(varValue)) {
      _isObject = true
      varValue = stringify(varValue)
      valueTemp = stringify(valueTemp)
    }
    let finalData = {};
    let submitable = false;
    let data = null;
    let dataTemp = null;
    if (varType === '' || varKey === '' || varValue === valueTemp) {
      submitable = false
    } else {
      submitable = true
      if (_isObject) {
        _isObject = false
        varValue = parse(varValue)
        valueTemp = parse(valueTemp)
      }
    }
    if (varValue !== valueTemp) {
      if (varType === 'str') {
        data = varValue;
      } else if (varType === 'int') {
        dataTemp = parseInt(varValue, 10);
        data = dataTemp;
      } else if (varType === 'obj') {
        dataTemp = parse(varValue);
        data = dataTemp;
      } else if (varType === 'arr') {
        dataTemp = parseArray(varValue);
        data = dataTemp;
      } else if (varType === 'func' || varType === 'device' || varType === 'filter') {
        data = varValue;
      }
    }
    if (name === 'varKey') {
      if (submitable) {
        submitable = !hasWhiteSpace(varKey)
      }
    }
    if (varType === 'filter') {
      if (safeDeepGetWithType(data, ['period'], '') === 'auto') {
        safeDeepDel(data, ['period'])
      }
    }
    finalData = {
      submitable,
      data
    }
    return finalData;
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let _parent = safeDeepGet(_props, ['_parent']);
    let catType = safeDeepGetWithType(_parent, ['state', 'finalCat'], '');
    let varType = safeDeepGetWithType(_state, ['varType'], '');
    let varKey = safeDeepGetWithType(_state, ['varKey'], '');
    let varValue = safeDeepGetWithType(_state, ['varValue'], '');
    let varVar = safeDeepGetWithType(_state, ['varVar'], '');
    let isSubmitable = safeDeepGetWithType(_state, ['isSubmitable'], false);
    let error = safeDeepGetWithType(_state, ['error'], false);
    let errorVarKey = false;
    let helperText = null;
    if (hasWhiteSpace(varKey)) {
      errorVarKey = true;
      helperText = 'Key tidak boleh mengandung spasi'
    }
    let isManual = safeDeepGetWithType(_state, ['isManual'], false);
    if (!isManual) {
      if (varType === 'func') {
        if (varKey.length < 6) {
          errorVarKey = true;
          helperText = 'Key dari function minimal 6 karakter'
        } else {
          let first = varKey.substring(0, 5);
          if (first !== 'func_') {
            errorVarKey = true;
            helperText = 'Key dari function harus diawali \'func_\''
          }
        }
      }
    }
    return (
      <Dialog
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        open={_parent.state.dialogAddVar}
        aria-labelledby="max-width-dialog-title"
        fullWidth={true}
        maxWidth={'md'}
      >
        <DialogTitle id="form-dialog-title">
          <span>
            <span>Tambah Variabel Baru</span>
            <span style={{ marginLeft: 10 }}>
              <FormControl required >
                <span>
                  <Switch size="small" checked={isManual} color="primary" onChange={() => _this.setState({ isManual: !isManual })} />
                  <i style={{ fontSize: 11 }}>Manual Code</i>
                </span>
              </FormControl>
            </span>
          </span>
        </DialogTitle>
        {isManual ?
          <DialogContent >
            <FormControl required style={{ minWidth: '100%' }} >
              <TextField
                label="Key"
                value={varKey}
                autoFocus
                error={errorVarKey}
                onChange={_this.handleChange}
                type="string"
                margin='dense'
                inputProps={{ name: "varKey" }}
                helperText={helperText}
              />
            </FormControl>
            <FormControl required style={{ minWidth: '100%' }} >
              <TextField
                label="Manual Code"
                error={error}
                value={varVar}
                multiline
                rows="15"
                margin='dense'
                onChange={_this.handleChange}
                inputProps={{ name: "varVar" }}
              />
            </FormControl>
          </DialogContent>
          :
          <DialogContent >
            <FormControl required style={{ minWidth: '100%' }} >
              <TextField
                label="Key"
                value={varKey}
                autoFocus
                error={errorVarKey}
                onChange={_this.handleChange}
                type="string"
                margin='dense'
                inputProps={{ name: "varKey" }}
                helperText={helperText}
              />
            </FormControl>
            <FormControl required style={{ minWidth: '100%' }} >
              <InputLabel>Tipe</InputLabel>
              <Select
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                value={varType}
                margin='dense'
                onChange={_this.handleChange}
                inputProps={{
                  name: 'varType'
                }}
              >
                <MenuItem disabled value="_!dasdsaSvsaasdas+dasda==">
                  <em>Predefined value with type</em>
                </MenuItem>
                <MenuItem value='arr'>Array</MenuItem>
                <MenuItem value='int'>Integer</MenuItem>
                <MenuItem value='obj'>Object</MenuItem>
                <MenuItem value='str'>String</MenuItem>
                {catType !== TYPE_LIST_TRANSACTION && !isCommand(catType) && catType !== '' &&
                  <MenuItem disabled value="_!dasdsaSvsaasdas+dasda==">
                    <em>Function variable</em>
                  </MenuItem>
                }
                {catType !== TYPE_LIST_TRANSACTION && !isCommand(catType) && catType !== '' &&
                  <MenuItem value='func'>Function</MenuItem>
                }
                {isCustomCommand(catType) &&
                  <MenuItem disabled value="_!dasdsaSvsaasdas+dasda==">
                    <em>Device Selector</em>
                  </MenuItem>
                }
                {isCustomCommand(catType) &&
                  <MenuItem value='device'>Device</MenuItem>
                }
              </Select>
            </FormControl>
            {varType === 'str' &&
              <FormControl required style={{ minWidth: '100%' }}  >
                <TextField
                  error={error}
                  label="String Value"
                  value={varValue}
                  onChange={_this.handleChange}
                  type="string"
                  margin='dense'
                  inputProps={{ name: "varValue" }}
                />
              </FormControl>
            }
            {varType === 'int' &&
              <FormControl required style={{ minWidth: '100%' }} >
                <TextField
                  label="Integer Value"
                  error={error}
                  value={varValue}
                  onChange={_this.handleChange}
                  margin='dense'
                  type="number"
                  inputProps={{ name: "varValue", min: "0", step: "1" }}
                />
              </FormControl>
            }
            {varType === 'obj' &&
              <FormControl required style={{ minWidth: '100%' }} >
                <TextField
                  label="Object Value"
                  error={error}
                  value={varValue}
                  multiline
                  rows="15"
                  margin='dense'
                  onChange={_this.handleChange}
                  inputProps={{ name: "varValue" }}
                />
              </FormControl>
            }
            {varType === 'arr' &&
              <FormControl required style={{ minWidth: '100%' }} >
                <TextField
                  label="Array Value"
                  error={error}
                  value={varValue}
                  multiline
                  rows="15"
                  margin='dense'
                  onChange={_this.handleChange}
                  inputProps={{ name: "varValue" }}
                />
              </FormControl>
            }
            {varType === 'func' &&
              <SelectionQuery _parent={_parent} checkSubmitable={this.checkSubmitable} />
            }
            {varType === 'device' &&
              <SelectionDevice _parent={_parent} checkSubmitable={this.checkSubmitable} />
            }
            {varType === 'filter' &&
              <SelectionFilter _parent={_parent} checkSubmitable={this.checkSubmitable} />
            }
          </DialogContent>
        }
        <DialogActions>
          <Button onClick={_this.handleClose} color="primary">Batal</Button>
          <Button disabled={!isSubmitable} onClick={_this.handleSave} variant="contained" color="primary">Simpan</Button>
        </DialogActions>
      </Dialog>
    )
  }
}